import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight, FiShoppingBag } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import Heading from "../../components/Heading";
import NoData from "../../components/NoData";
import SingleProduct from "../../components/product/SingleProduct";
import { getProducts } from "../../redux/features/ProductSlice";

const WeeklyDeals = ({ category_id }) => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  useEffect(() => {
    dispatch(getProducts({ limit: 50, weekly: 1, category_id }));
  }, [category_id, dispatch]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640);
      setIsTablet(window.innerWidth >= 640 && window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const products =
    useSelector((state) => state.mainproduct.weeklyProducts) || [];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : isTablet ? 2 : 4,
    slidesToScroll: 1,
    autoplay: !isHovered,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const nextSlide = () => sliderRef.current.slickNext();
  const prevSlide = () => sliderRef.current.slickPrev();

  return (
    <div className="relative py-6">
      {products.length > (isMobile ? 1 : isTablet ? 2 : 4) && (
        <div className="absolute top-[6.5rem] right-0 z-10 flex space-x-2">
          <motion.button
            className="p-2 bg-white rounded-full shadow-md hover:shadow-xl"
            onClick={prevSlide}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FiChevronLeft className="text-xl text-gray-800" />
          </motion.button>
          <motion.button
            className="p-2 bg-white rounded-full shadow-md hover:shadow-xl"
            onClick={nextSlide}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FiChevronRight className="text-xl text-gray-800" />
          </motion.button>
        </div>
      )}
      <div className="flex flex-col items-start justify-between mb-8 sm:flex-row sm:items-center">
        <div className="flex items-center mb-4 sm:mb-0">
          <motion.div
            initial={{ rotate: -10, scale: 0.9 }}
            animate={{ rotate: 0, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20,
              repeat: Infinity,
              repeatType: "reverse",
              duration: 1.5,
            }}
            className="mr-3"
          ></motion.div>
          <div className="">
            <Heading title="Weekly Flash Deals" />
            <p className="mt-1 text-gray-600">
              Exclusive offers that refresh every week
            </p>
          </div>
        </div>
      </div>

      {products?.length ? (
        <div
          className="relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Slider ref={sliderRef} {...settings}>
            {products.map((product, index) => (
              <div key={index} className="px-2">
                <motion.div
                  className="relative overflow-hidden transition-all duration-300 bg-white shadow-md rounded-2xl hover:shadow-lg"
                  whileHover={{ y: -5 }}
                >
                  <SingleProduct product={product} />
                  <motion.div
                    className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40"
                    initial={{ opacity: 0 }}
                    whileHover={{ opacity: 1 }}
                  >
                    <motion.button
                      className="flex items-center px-4 py-2 font-medium text-black bg-white rounded-full shadow-md"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => navigate(`/product/${product?.slug}`)}
                    >
                      <FiShoppingBag className="mr-2" /> Quick Shop
                    </motion.button>
                  </motion.div>
                </motion.div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default WeeklyDeals;

// import {
//   AnimatePresence,
//   motion,
//   useAnimation,
//   useInView,
// } from "framer-motion";
// import { useEffect, useRef, useState } from "react";
// import {
//   FiChevronLeft,
//   FiChevronRight,
//   FiEye,
//   FiHeart,
//   FiShoppingBag,
// } from "react-icons/fi";
// import {
//   IoMdFlash,
//   IoMdPricetag,
//   IoMdStar,
//   IoMdStarHalf,
// } from "react-icons/io";
// import { MdOutlineLocalOffer } from "react-icons/md";
// // import { PiCookingPot, PiMixer } from "react-icons/pi";
// import { GiCoffeePot, GiKitchenKnives, GiToaster } from "react-icons/gi";
// // import { TbRefrigerator } from "react-icons/tb";

// // Mock data for kitchen appliances - keeping the same data
// const products = [
//   {
//     id: 1,
//     name: "Pro Kitchen Mixer 5000",
//     slug: "pro-kitchen-mixer-5000",
//     price: 299.99,
//     discountedPrice: 199.99,
//     discountPercentage: 33,
//     rating: 4.8,
//     image: "/placeholder.svg?height=300&width=300",
//     category: "mixers",
//     icon: <GiKitchenKnives className="w-6 h-6" />,
//     featured: true,
//   },
//   {
//     id: 2,
//     name: "Smart Toaster Deluxe",
//     slug: "smart-toaster-deluxe",
//     price: 89.99,
//     discountedPrice: 59.99,
//     discountPercentage: 33,
//     rating: 4.5,
//     image: "/placeholder.svg?height=300&width=300",
//     category: "toasters",
//     icon: <GiToaster className="w-6 h-6" />,
//   },
//   {
//     id: 3,
//     name: "Precision Coffee Maker",
//     slug: "precision-coffee-maker",
//     price: 149.99,
//     discountedPrice: 99.99,
//     discountPercentage: 33,
//     rating: 4.7,
//     image: "/placeholder.svg?height=300&width=300",
//     category: "coffee",
//     icon: <GiCoffeePot className="w-6 h-6" />,
//     featured: true,
//   },
//   {
//     id: 4,
//     name: "Chef's Knife Set Premium",
//     slug: "chefs-knife-set-premium",
//     price: 199.99,
//     discountedPrice: 129.99,
//     discountPercentage: 35,
//     rating: 4.9,
//     image: "/placeholder.svg?height=300&width=300",
//     category: "knives",
//     icon: <GiKitchenKnives className="w-6 h-6" />,
//   },
//   {
//     id: 5,
//     name: "Smart Refrigerator Pro",
//     slug: "smart-refrigerator-pro",
//     price: 1299.99,
//     discountedPrice: 999.99,
//     discountPercentage: 23,
//     rating: 4.6,
//     image: "/placeholder.svg?height=300&width=300",
//     category: "refrigerators",
//     icon: <GiKitchenKnives className="w-6 h-6" />,
//     featured: true,
//   },
//   {
//     id: 6,
//     name: "Ceramic Cookware Set",
//     slug: "ceramic-cookware-set",
//     price: 249.99,
//     discountedPrice: 179.99,
//     discountPercentage: 28,
//     rating: 4.4,
//     image: "/placeholder.svg?height=300&width=300",
//     category: "cookware",
//     icon: <GiKitchenKnives className="w-6 h-6" />,
//   },
// ];

// // Animation variants
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.05,
//       delayChildren: 0.2,
//     },
//   },
// };

// const itemVariants = {
//   hidden: { opacity: 0, scale: 0.9 },
//   visible: {
//     opacity: 1,
//     scale: 1,
//     transition: {
//       type: "spring",
//       stiffness: 100,
//       damping: 15,
//     },
//   },
// };

// const fadeInUp = {
//   hidden: { y: 20, opacity: 0 },
//   visible: {
//     y: 0,
//     opacity: 1,
//     transition: {
//       type: "spring",
//       stiffness: 100,
//       damping: 15,
//     },
//   },
// };

// const WeeklyDeals = ({ category_id = null }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const [timeLeft, setTimeLeft] = useState({
//     days: 3,
//     hours: 12,
//     minutes: 45,
//     seconds: 30,
//   });
//   const containerRef = useRef(null);
//   const isInView = useInView(containerRef, { once: false, amount: 0.2 });
//   const controls = useAnimation();
//   const [activeCategory, setActiveCategory] = useState("all");

//   // Screen size detection
//   const [isMobile, setIsMobile] = useState(false);
//   const [isTablet, setIsTablet] = useState(false);

//   useEffect(() => {
//     // Check screen size
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth < 640);
//       setIsTablet(window.innerWidth >= 640 && window.innerWidth < 1024);
//     };

//     checkScreenSize();
//     window.addEventListener("resize", checkScreenSize);

//     return () => window.removeEventListener("resize", checkScreenSize);
//   }, []);

//   // Animate when in view
//   useEffect(() => {
//     if (isInView) {
//       controls.start("visible");
//     }
//   }, [controls, isInView]);

//   // Countdown timer
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setTimeLeft((prev) => {
//         let { days, hours, minutes, seconds } = prev;

//         if (seconds > 0) {
//           seconds -= 1;
//         } else {
//           seconds = 59;
//           if (minutes > 0) {
//             minutes -= 1;
//           } else {
//             minutes = 59;
//             if (hours > 0) {
//               hours -= 1;
//             } else {
//               hours = 23;
//               if (days > 0) {
//                 days -= 1;
//               } else {
//                 // Reset to a week when countdown ends
//                 days = 6;
//                 hours = 23;
//                 minutes = 59;
//                 seconds = 59;
//               }
//             }
//           }
//         }

//         return { days, hours, minutes, seconds };
//       });
//     }, 1000);

//     return () => clearInterval(timer);
//   }, []);

//   const getVisibleCount = () => {
//     if (isMobile) return 1;
//     if (isTablet) return 2;
//     return 3;
//   };

//   const nextSlide = () => {
//     if (filteredProducts.length <= getVisibleCount()) return;
//     setCurrentIndex((prev) =>
//       prev + 1 >= filteredProducts.length - getVisibleCount() + 1 ? 0 : prev + 1
//     );
//   };

//   const prevSlide = () => {
//     if (filteredProducts.length <= getVisibleCount()) return;
//     setCurrentIndex((prev) =>
//       prev === 0 ? filteredProducts.length - getVisibleCount() : prev - 1
//     );
//   };

//   const goToSlide = (index) => {
//     const maxIndex = Math.max(0, filteredProducts.length - getVisibleCount());
//     setCurrentIndex(Math.min(index, maxIndex));
//   };

//   // Format time with leading zeros
//   const formatTime = (value) => value.toString().padStart(2, "0");

//   // Filter products by category
//   const filteredProducts =
//     activeCategory === "all"
//       ? products
//       : products.filter((product) => product.category === activeCategory);

//   // Calculate percentage for progress bar
//   const progressPercentage =
//     filteredProducts.length <= getVisibleCount()
//       ? 100
//       : (currentIndex / (filteredProducts.length - getVisibleCount())) * 100;

//   // Categories for filter
//   const categories = [
//     { id: "all", name: "All Items", icon: <MdOutlineLocalOffer /> },
//     { id: "mixers", name: "Mixers", icon: <GiKitchenKnives /> },
//     { id: "toasters", name: "Toasters", icon: <GiToaster /> },
//     { id: "coffee", name: "Coffee Makers", icon: <GiCoffeePot /> },
//     { id: "refrigerators", name: "Refrigerators", icon: <GiKitchenKnives /> },
//     { id: "cookware", name: "Cookware", icon: <GiKitchenKnives /> },
//   ];

//   // Auto-advance carousel
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (filteredProducts.length > getVisibleCount()) {
//         nextSlide();
//       }
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [currentIndex, filteredProducts.length, nextSlide]);

//   return (
//     <motion.div
//       ref={containerRef}
//       className="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white"
//       variants={containerVariants}
//       initial="hidden"
//       animate={controls}
//     >
//       {/* Header Section with Countdown */}
//       <motion.div
//         className="flex flex-col items-start justify-between mb-12 sm:flex-row sm:items-center"
//         variants={fadeInUp}
//       >
//         <div className="flex flex-col mb-6 sm:mb-0">
//           <div className="flex items-center mb-2">
//             <motion.div
//               initial={{ rotate: -10, scale: 0.9 }}
//               animate={{
//                 rotate: [0, -10, 0, -10, 0],
//                 scale: [1, 1.1, 1, 1.1, 1],
//               }}
//               transition={{
//                 duration: 2,
//                 repeat: Number.POSITIVE_INFINITY,
//                 repeatType: "loop",
//                 ease: "easeInOut",
//                 times: [0, 0.25, 0.5, 0.75, 1],
//               }}
//               className="mr-3"
//             >
//               <IoMdFlash className="text-4xl text-amber-500 sm:text-5xl" />
//             </motion.div>
//             <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
//               Weekly Flash Deals
//             </h2>
//           </div>
//           <p className="max-w-xl mt-1 text-lg text-gray-600">
//             Premium kitchen appliances at unbeatable prices
//           </p>
//         </div>

//         {/* Countdown Timer */}
//         <motion.div
//           className="flex flex-col items-center px-6 py-4 bg-white shadow-md rounded-xl"
//           whileHover={{
//             scale: 1.02,
//             boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <div className="mb-2 text-sm font-medium text-gray-500">
//             FLASH SALE ENDS IN
//           </div>
//           <div className="flex items-center space-x-3">
//             <div className="flex flex-col items-center">
//               <div className="text-2xl font-bold text-gray-900">
//                 {timeLeft.days}
//               </div>
//               <div className="text-xs text-gray-500">Days</div>
//             </div>
//             <div className="text-xl font-bold text-gray-300">:</div>
//             <div className="flex flex-col items-center">
//               <div className="text-2xl font-bold text-gray-900">
//                 {formatTime(timeLeft.hours)}
//               </div>
//               <div className="text-xs text-gray-500">Hours</div>
//             </div>
//             <div className="text-xl font-bold text-gray-300">:</div>
//             <div className="flex flex-col items-center">
//               <div className="text-2xl font-bold text-gray-900">
//                 {formatTime(timeLeft.minutes)}
//               </div>
//               <div className="text-xs text-gray-500">Mins</div>
//             </div>
//             <div className="text-xl font-bold text-gray-300">:</div>
//             <div className="flex flex-col items-center">
//               <div className="text-2xl font-bold text-gray-900">
//                 {formatTime(timeLeft.seconds)}
//               </div>
//               <div className="text-xs text-gray-500">Secs</div>
//             </div>
//           </div>
//         </motion.div>
//       </motion.div>

//       {/* Category Filter */}
//       <motion.div
//         className="flex flex-wrap items-center gap-3 mb-10"
//         variants={fadeInUp}
//       >
//         {categories.map((category) => (
//           <motion.button
//             key={category.id}
//             className={`flex items-center px-5 py-2.5 text-sm font-medium rounded-lg transition-all ${
//               activeCategory === category.id
//                 ? "bg-amber-500 text-white shadow-md"
//                 : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
//             }`}
//             onClick={() => {
//               setActiveCategory(category.id);
//               setCurrentIndex(0);
//             }}
//             whileHover={{ scale: 1.03 }}
//             whileTap={{ scale: 0.97 }}
//           >
//             <span className="mr-2">{category.icon}</span>
//             {category.name}
//           </motion.button>
//         ))}
//       </motion.div>

//       {/* Products Carousel */}
//       {filteredProducts.length > 0 ? (
//         <motion.div className="relative" variants={fadeInUp}>
//           <div className="overflow-hidden" ref={containerRef}>
//             <motion.div
//               className="flex"
//               animate={{
//                 translateX: `-${currentIndex * (100 / getVisibleCount())}%`,
//               }}
//               transition={{ type: "spring", stiffness: 100, damping: 20 }}
//               style={{
//                 width: `${
//                   (filteredProducts.length / getVisibleCount()) * 100
//                 }%`,
//               }}
//             >
//               {filteredProducts.map((product, index) => (
//                 <motion.div
//                   key={product.id}
//                   className="relative"
//                   style={{
//                     width: `${100 / getVisibleCount()}%`,
//                     padding: "0 1rem",
//                   }}
//                   onHoverStart={() => setHoveredIndex(index)}
//                   onHoverEnd={() => setHoveredIndex(null)}
//                   variants={itemVariants}
//                 >
//                   <motion.div
//                     className="relative h-full overflow-hidden transition-all duration-300 bg-white border-0 shadow-lg rounded-xl hover:shadow-xl"
//                     whileHover={{
//                       y: -8,
//                       boxShadow:
//                         "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
//                     }}
//                     style={{
//                       background: "linear-gradient(145deg, #ffffff, #f5f5f5)",
//                       boxShadow:
//                         "10px 10px 20px #d9d9d9, -10px -10px 20px #ffffff",
//                     }}
//                   >
//                     {/* Featured Badge */}
//                     {product.featured && (
//                       <motion.div
//                         className="absolute top-0 left-0 z-10 px-3 py-1 text-xs font-bold text-white rounded-br-lg bg-gradient-to-r from-amber-500 to-amber-600"
//                         initial={{ y: -30 }}
//                         animate={{ y: 0 }}
//                         transition={{
//                           type: "spring",
//                           stiffness: 300,
//                           damping: 20,
//                         }}
//                       >
//                         FEATURED
//                       </motion.div>
//                     )}

//                     {/* Sale Badge */}
//                     <motion.div
//                       initial={{ scale: 0.8, opacity: 0 }}
//                       animate={{ scale: 1, opacity: 1 }}
//                       transition={{ delay: index * 0.1 }}
//                       className="absolute z-10 flex items-center px-3 py-1 text-sm font-bold text-white rounded-full bg-gradient-to-r from-red-500 to-pink-500 top-4 right-4"
//                     >
//                       <IoMdPricetag className="mr-1" />
//                       <span>-{product.discountPercentage}%</span>
//                     </motion.div>

//                     {/* Product Image */}
//                     <div className="relative pt-6 overflow-hidden">
//                       <motion.div
//                         className="flex items-center justify-center p-6"
//                         whileHover={{ scale: 1.05 }}
//                       >
//                         <img
//                           src={product.image || "/placeholder.svg"}
//                           alt={product.name}
//                           className="object-contain w-full h-48"
//                         />
//                       </motion.div>

//                       {/* Category Icon */}
//                       <div className="absolute flex items-center justify-center w-12 h-12 text-white rounded-full bg-gradient-to-br from-gray-700 to-gray-900 top-4 left-4">
//                         {product.icon}
//                       </div>
//                     </div>

//                     {/* Product Info */}
//                     <div className="p-6 -mt-4 bg-white rounded-t-3xl rounded-b-xl">
//                       <h3 className="mb-2 text-lg font-bold text-gray-900">
//                         {product.name}
//                       </h3>

//                       {/* Rating */}
//                       <div className="flex items-center mb-3">
//                         <div className="flex text-amber-400">
//                           {[...Array(Math.floor(product.rating))].map(
//                             (_, i) => (
//                               <IoMdStar key={i} />
//                             )
//                           )}
//                           {product.rating % 1 !== 0 && <IoMdStarHalf />}
//                         </div>
//                         <span className="ml-2 text-sm text-gray-600">
//                           {product.rating.toFixed(1)}
//                         </span>
//                       </div>

//                       {/* Price */}
//                       <div className="flex items-center justify-between mt-4">
//                         <div className="flex flex-col">
//                           <span className="text-sm text-gray-500 line-through">
//                             ${product.price}
//                           </span>
//                           <span className="text-2xl font-bold text-gray-900">
//                             ${product.discountedPrice}
//                           </span>
//                         </div>
//                         <div className="flex space-x-2">
//                           <motion.button
//                             className="flex items-center justify-center w-10 h-10 text-gray-700 bg-gray-100 rounded-full"
//                             whileHover={{
//                               scale: 1.1,
//                               backgroundColor: "#f3f4f6",
//                             }}
//                             whileTap={{ scale: 0.9 }}
//                           >
//                             <FiHeart className="w-5 h-5" />
//                           </motion.button>
//                           <motion.button
//                             className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-full bg-gradient-to-r from-amber-500 to-amber-600"
//                             whileHover={{ scale: 1.05, x: 3 }}
//                             whileTap={{ scale: 0.95 }}
//                           >
//                             <FiShoppingBag className="w-4 h-4 mr-1" />
//                             Add
//                           </motion.button>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Quick View Overlay - Appears on hover */}
//                     <AnimatePresence>
//                       {hoveredIndex === index && (
//                         <motion.div
//                           initial={{ opacity: 0 }}
//                           animate={{ opacity: 1 }}
//                           exit={{ opacity: 0 }}
//                           className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm"
//                         >
//                           <motion.button
//                             initial={{ y: 20, opacity: 0 }}
//                             animate={{ y: 0, opacity: 1 }}
//                             transition={{ delay: 0.1 }}
//                             className="flex items-center px-6 py-3 text-sm font-medium text-white bg-black rounded-full"
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                           >
//                             <FiEye className="mr-2" />
//                             Quick View
//                           </motion.button>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </motion.div>
//                 </motion.div>
//               ))}
//             </motion.div>
//           </div>

//           {/* Navigation Arrows */}
//           {filteredProducts.length > getVisibleCount() && (
//             <>
//               <motion.button
//                 className="absolute z-10 flex items-center justify-center w-12 h-12 transform -translate-y-1/2 bg-white rounded-full shadow-lg top-1/2 -left-6"
//                 onClick={prevSlide}
//                 whileHover={{
//                   scale: 1.1,
//                   boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
//                 }}
//                 whileTap={{ scale: 0.9 }}
//                 disabled={currentIndex === 0}
//                 initial={{ opacity: 0.6 }}
//                 animate={{ opacity: currentIndex === 0 ? 0.6 : 1 }}
//                 style={{
//                   boxShadow: "5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff",
//                 }}
//               >
//                 <FiChevronLeft
//                   className={`text-xl ${
//                     currentIndex === 0 ? "text-gray-400" : "text-gray-800"
//                   }`}
//                 />
//               </motion.button>
//               <motion.button
//                 className="absolute z-10 flex items-center justify-center w-12 h-12 transform -translate-y-1/2 bg-white rounded-full shadow-lg top-1/2 -right-6"
//                 onClick={nextSlide}
//                 whileHover={{
//                   scale: 1.1,
//                   boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
//                 }}
//                 whileTap={{ scale: 0.9 }}
//                 disabled={
//                   currentIndex >= filteredProducts.length - getVisibleCount()
//                 }
//                 initial={{ opacity: 0.6 }}
//                 animate={{
//                   opacity:
//                     currentIndex >= filteredProducts.length - getVisibleCount()
//                       ? 0.6
//                       : 1,
//                 }}
//                 style={{
//                   boxShadow: "5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff",
//                 }}
//               >
//                 <FiChevronRight
//                   className={`text-xl ${
//                     currentIndex >= filteredProducts.length - getVisibleCount()
//                       ? "text-gray-400"
//                       : "text-gray-800"
//                   }`}
//                 />
//               </motion.button>
//             </>
//           )}

//           {/* Progress Bar and Dots */}
//           <div className="px-4 mt-10">
//             <div className="w-full h-1 overflow-hidden bg-gray-200 rounded-full">
//               <motion.div
//                 className="h-full rounded-full bg-amber-500"
//                 initial={{ width: 0 }}
//                 animate={{ width: `${progressPercentage}%` }}
//                 transition={{ duration: 0.3 }}
//               />
//             </div>

//             {/* Dots Navigation */}
//             <div className="flex justify-center mt-4 space-x-2">
//               {Array.from({
//                 length: Math.min(
//                   5,
//                   Math.ceil(filteredProducts.length / getVisibleCount())
//                 ),
//               }).map((_, idx) => {
//                 const slideIndex =
//                   idx *
//                   Math.ceil(filteredProducts.length / 5 / getVisibleCount());
//                 return (
//                   <motion.button
//                     key={idx}
//                     className={`w-3 h-3 rounded-full ${
//                       currentIndex === slideIndex
//                         ? "bg-amber-500"
//                         : "bg-gray-300"
//                     }`}
//                     onClick={() => goToSlide(slideIndex)}
//                     whileHover={{ scale: 1.5 }}
//                     whileTap={{ scale: 0.9 }}
//                   />
//                 );
//               })}
//             </div>
//           </div>
//         </motion.div>
//       ) : (
//         <motion.div
//           className="flex flex-col items-center justify-center p-10 text-center bg-white rounded-lg shadow-md"
//           variants={fadeInUp}
//         >
//           <motion.div
//             initial={{ scale: 0.8, opacity: 0 }}
//             animate={{ scale: 1, opacity: 1 }}
//             transition={{ delay: 0.2 }}
//           >
//             <GiKitchenKnives className="w-16 h-16 mb-4 text-gray-400" />
//           </motion.div>
//           <h3 className="text-xl font-medium text-gray-700">
//             No products found
//           </h3>
//           <p className="mt-2 text-gray-500">
//             Try selecting a different category or check back later
//           </p>
//         </motion.div>
//       )}

//       {/* View All Deals Button */}
//       <motion.div className="flex justify-center mt-12" variants={fadeInUp}>
//         <motion.button
//           className="px-8 py-3 text-lg font-medium text-white rounded-full shadow-md bg-gradient-to-r from-amber-500 to-amber-600"
//           whileHover={{
//             scale: 1.05,
//             boxShadow:
//               "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           View All Deals
//         </motion.button>
//       </motion.div>
//     </motion.div>
//   );
// };

// export default WeeklyDeals;

// asdasda
// s
